import './events.css';
import React from 'react'
import Navbar from "../../components/Header/Navbar/Navbar.js"
import Topnavbar from "../../components/Header/Topnavbar/Topnavbar.js"
import Footer from "../../components/Footer/Footer.js"

function Events() {
  return (
    <>
      <Topnavbar/>
      <Navbar/>
      <div className='container-main-events'>
        <div className='container-main-circle'>
          <p><b>Events page</b>: Under construction</p>
        </div>
      </div>
      <Footer/>
    </>
  )
}

export default Events